<template>
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 512 512"><path d="M504.5 75.5c-10-10-26.2-10-36.2 0L161.6 382.2 43.7 264.31a25.6 25.6 0 0 0-36.2 36.2l136 136a25.6 25.6 0 0 0 36.2 0L504.5 111.7c10-10 10-26.2 0-36.2"/></svg>
</template>
